import { RouteRecordRaw } from 'vue-router'

export interface PermissionState {
    routes: any
    dynamicRoutes: any
    whitePaths: string
    activeRoute?: string
}

export const state: PermissionState = {
    routes: localStorage.getItem('routes') || [],
    dynamicRoutes: localStorage.getItem('dynamicRoutes') || [],
    whitePaths: localStorage.getItem('whitePaths') || '',
    activeRoute: ''
}